module.exports = __webpack_public_path__ + "static/media/socialMobile.1365354f.png";